"use client";

import { forwardRef } from "react";

import cx from "classnames";

const InputOTPGroup = forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cx("flex items-center space-x-4 md:space-x-5", className)}
    {...props}
    dir="ltr"
  />
));
InputOTPGroup.displayName = "InputOTPGroup";

export default InputOTPGroup;
